export default "__VITE_ASSET__CLi$jZov__"